import React from 'react';
import { Box, Stack, Text } from 'braid-design-system';

interface QuotationPrintModalProps {
  orderNo: string;
  customerName: string;
  amount: number;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const QuotationPrintModal: React.FC<QuotationPrintModalProps> = ({
  orderNo,
  customerName,
  amount,
  isLoading,
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="search-modal-overlay">
      <div className="search-modal billing-receipt-print-modal">
        <div className="search-modal-header">
          <div>
            <Text weight="strong" size="large">
              Print Quotation
            </Text>
            <div className="billing-receipt-print-subtitle">
              <Text tone="secondary" size="small">
                Order {orderNo}
              </Text>
            </div>
          </div>
          <button
            type="button"
            onClick={() => {
              if (!isLoading) {
                onCancel();
              }
            }}
            className="search-modal-close"
            disabled={isLoading}
          >
            x
          </button>
        </div>

        <div className="search-modal-content billing-receipt-print-content">
          <Stack space="medium">
            <Text>
              Order saved. Do you want to print this quotation?
            </Text>

            <Box display="flex" justifyContent="spaceBetween" alignItems="center">
              <Text tone="secondary" size="small">
                {customerName || 'Walk-in'}
              </Text>
              <Text weight="strong">
                {amount.toFixed(2)}
              </Text>
            </Box>

            <Box display="flex" justifyContent="flexEnd" gap="small">
              <button
                type="button"
                className="billing-bottom-btn clear"
                onClick={onCancel}
                disabled={isLoading}
              >
                No
              </button>
              <button
                type="button"
                className="billing-bottom-btn charge"
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? 'Printing...' : 'Print (A4)'}
              </button>
            </Box>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default QuotationPrintModal;
